import { c as _c } from "react/compiler-runtime";
import type { JSX } from "react";
import { routeSrcset, toStorefrontMediaUrl } from '@/lib/media-url';
import type { ResponsiveImageBlock } from '../types';
import { RichSegments } from './RichSegments';
import styles from './Image.module.css';
interface ResponsiveImageProps {
  block: ResponsiveImageBlock;
  blockId: string;
}
export function ResponsiveImage(t0) {
  const $ = _c(26);
  const {
    block,
    blockId
  } = t0;
  const {
    sources,
    fallback,
    caption,
    href,
    target,
    rel
  } = block;
  let t1;
  if ($[0] !== sources) {
    t1 = sources.map(_temp);
    $[0] = sources;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== fallback.src) {
    t2 = toStorefrontMediaUrl(fallback.src);
    $[2] = fallback.src;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = fallback.sourceSrc ?? fallback.src;
  let t4;
  if ($[4] !== fallback.alt || $[5] !== fallback.height || $[6] !== fallback.width || $[7] !== t2 || $[8] !== t3) {
    t4 = <img src={t2} alt={fallback.alt} width={fallback.width} height={fallback.height} className={styles.image} loading="lazy" data-src={t3} />;
    $[4] = fallback.alt;
    $[5] = fallback.height;
    $[6] = fallback.width;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t1 || $[11] !== t4) {
    t5 = <picture className={styles.staticWrapper}>{t1}{t4}</picture>;
    $[10] = t1;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== caption) {
    t6 = caption && caption.length > 0 ? <figcaption className={styles.caption}><RichSegments segments={caption} /></figcaption> : null;
    $[13] = caption;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== blockId || $[16] !== t5 || $[17] !== t6) {
    t7 = <figure className={styles.figure} data-cms-block-id={blockId} data-cms-field="responsiveImage">{t5}{t6}</figure>;
    $[15] = blockId;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const figure = t7;
  if (href) {
    let t8;
    if ($[19] !== href) {
      t8 = toStorefrontMediaUrl(href);
      $[19] = href;
      $[20] = t8;
    } else {
      t8 = $[20];
    }
    let t9;
    if ($[21] !== figure || $[22] !== rel || $[23] !== t8 || $[24] !== target) {
      t9 = <a href={t8} target={target} rel={rel} className={styles.link}>{figure}</a>;
      $[21] = figure;
      $[22] = rel;
      $[23] = t8;
      $[24] = target;
      $[25] = t9;
    } else {
      t9 = $[25];
    }
    return t9;
  }
  return figure;
}
function _temp(source, idx) {
  return <source key={idx} media={source.media} srcSet={routeSrcset(source.srcset)} type={source.type} />;
}